import Vue from 'vue'
import Router from 'vue-router'
/*import Login from './users/components/Login.vue'*/
import Top from './top/Top.vue'
import About from './about/About.vue'
import Menu from './menu/Menu.vue'
import SalonList from './salonlist/SalonList.vue'
import FAQ from './faq/FAQ.vue'
import System from './system/System.vue'
import Machine from './machine/Machine.vue'
import Company from './company/Company.vue'
import Contact from './contact/Contact.vue'
import PrivacyPolicy from './privacypolicy/PrivacyPolicy.vue'
import SCTL from './sctl/SCTL.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { //トップページ
      path: '/',
      name: 'top',
      component: Top
    },
    { // セルフエステエンリケについて
      path: '/about',
      name: 'about',
      component: About
    },
    { // 料金表
      path: '/menu',
      name: 'menu',
      component: Menu
    },
    { // 店舗一覧
      path: '/salonlist',
      name: 'salonlist',
      component: SalonList
    },
    { // FAQ
      path: '/faq',
      name: 'faq',
      component: FAQ
    },
    { // システムについて
      path: '/system',
      name: 'system',
      component: System
    },
    { // 機械について
      path: '/machine',
      name: 'machine',
      component: Machine
    },
    { // 会社概要
      path: '/company',
      name: 'company',
      component: Company
    },
    { // お問い合わせ
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    { // プライバシーポリシー
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: PrivacyPolicy
    },
    { // 特定商取引法に基づく表記
      path: '/sctl',
      name: 'sctl',
      component: SCTL
    },
  ]
})

export default router;